import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { UploadUrl } from '../models';

@Injectable({ providedIn: 'root' })
export class UploadService {

  private baseUrl = environment.apiBaseUrl + '/media';

  constructor(private http: HttpClient) { }

  getMedia(key : string): Observable<any> {
    return this.http.get<any>(this.baseUrl + "/" + key);
  }

  getUploadUrl(): Observable<UploadUrl> {
    return this.http.post<UploadUrl>(this.baseUrl + '/new', {});
  }

  uploadWithProgress(file: File, uploadUrl: string) {
    const formData = new FormData();
    formData.append('file', file);

    // Step 2: Upload to R2 with the presigned URL
    const headers = new HttpHeaders({
      'Content-Type': file.type || 'application/octet-stream'
    });

    return this.http.put(uploadUrl, file, {
      headers,
      reportProgress: true,
      observe: 'events',
      responseType: 'text' // Important: R2 returns text response
    });
  }
}